import { render, staticRenderFns } from "./customerdiscount.vue?vue&type=template&id=5d510b5f&scoped=true"
import script from "./customerdiscount.vue?vue&type=script&lang=js"
export * from "./customerdiscount.vue?vue&type=script&lang=js"
import style0 from "./customerdiscount.vue?vue&type=style&index=0&id=5d510b5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d510b5f",
  null
  
)

export default component.exports